export class DPCustomer {
    'customer_id': number;
    'company_name': string;
    'primary_contact_name': string;
    'primary_contact_number': string;
    'primary_contact_email': string;
    'status': number;

}




// WEBPACK FOOTER //
// ./src/app/portalv1/dp-customer.ts